import { render } from "./userView.vue?vue&type=template&id=1b7331c6"
import script from "./userView.vue?vue&type=script&lang=js"
export * from "./userView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__